import { Component, EventEmitter, OnInit } from '@angular/core';
import { DwButtonCommand, DwButtonConfig, DwEventService, DwFileDetail, DwFileUploadModalResult, DwFileUtilService, DwMediaUploadResult, DwMessage, DwMessageSeverity, DwModalConfig, DwModalHandler, DwModalResult, DwOrmDataService } from '@devwareapps/devware-cap';
import { Observable, combineLatest, of } from 'rxjs';
import { AppMetaData, QuizEntity, QuizResultEntity, StudentModuleLessonActivityQueryEntity } from '../../../../meta-data/app-meta-data.service';
import { QuizRepositoryService } from '../../services/quiz-repository.service';
import { QuizHomeView } from '../../models/quiz-home-view.enum';
import { QuizCompleteResult } from '../../models/quiz-complete-result.model';
import { QuizViewAction, QuizViewActionType } from '../../models/quiz-view-action.enum';
import { QuizResultModalConfig } from '../../models/quiz-result-modal-config.model';
import { QuizTestModalConfig } from '../../models/quiz-test-modal-config.model';
import { QuizTestModeOptions } from '../../models/quiz-test-mode-options.model';

@Component({
  selector: 'app-quiz-test-modal',
  templateUrl: './quiz-test-modal.component.html',
  styleUrls: ['./quiz-test-modal.component.scss']
})
export class QuizTestModalComponent implements OnInit, DwModalHandler {
  modalConfig: DwModalConfig<QuizTestModalConfig>;
  closeModal = new EventEmitter<DwModalResult<any>>();
  
  quizResult: QuizResultEntity;
  quiz: QuizEntity;

  view: QuizHomeView = QuizHomeView.quiz;

  startingQuizResultQuestionId: number;

  testModeOptions: QuizTestModeOptions = {
    ShowAllQuestions: true,
    ShowInRandomOrder: true,
    ShowAnswers: true,
    ShowAI: true,
    ShowQuizNav: true
  }

  constructor(
    private quizRepositoryService: QuizRepositoryService,
  ) { }

  ngOnInit(): void {
    this.loadQuizResultData();
  }

  close() {
    let result = new DwModalResult();

    result.cancelled = true;

    this.closeModal.emit(result);
  }

  loadQuizResultData() {
    const obs : Observable<any>[] = [];

    obs.push(this.quizRepositoryService.getQuiz(this.modalConfig.data.quizId));

    combineLatest(obs).subscribe(([quiz]) => {
      this.quiz = quiz;
    });
  }

  buttonClick(buttonConfig: DwButtonConfig): Observable<DwModalResult<any>> {
    let result = new DwModalResult();

    result.cancelled = false;


    switch (buttonConfig.command) {
      case DwButtonCommand.ok:
      case DwButtonCommand.saveAndClose:
      case DwButtonCommand.save:
        
        return of(result);

      case DwButtonCommand.cancel:
        result.closeModal = true;
        result.cancelled = true;
    }

    return of(result);
  }
  
  quizComplete(event: QuizCompleteResult) {
    this.close();
    //this.view = QuizHomeView.lastResult;
  }

  quizResultAction(action: QuizViewAction) {
    if (action.isCancelled) {
      this.view = QuizHomeView.lastResult;
      return;
    }

    switch (action.actionType) {
      case QuizViewActionType.viewAnswers:
        this.view= QuizHomeView.quizAnswers;
        break;
    }

  }
}